import AuthenticationPage from "../pages/auth/authentication/AuthenticationPage.vue";
import RegistrationPage from "../pages/auth/registration/RegistrationPage.vue";
import i18n from '../i18n';

const authRoutes = [
    {
        path: '/app/authentication',
        name: "AuthenticationPage",
        component: AuthenticationPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("auth.authentication.title") }
                ]
            }
        }
    },
    {
        path: '/app/registration',
        name: "RegistrationPage",
        component: RegistrationPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("auth.registration.title") }
                ]
            }
        }
    },
]

export default authRoutes
